import adminGetNewsType from "@/api/user/admin-controler/adminGetNewsType";

export default function addNewsListNewsTypes() {
    return new Promise((resolve) => {
        adminGetNewsType().then(res => {
            let types = res.data
            types.sort((a,b)=>a.order-b.order)

            let map = new Map()
            for (let i = 0; i < types.length; i++) {
                let type = types[i]
                if(type.parentId==0) continue
                let children = map.get(type.parentId)
                if(!children){
                    children = []
                }
                children.push({
                    value:type.id,
                    label:type.name
                })
                map.set(type.parentId,children)
            }

            let data = []
            for (let i = 0; i < types.length; i++) {
                let type = types[i]
                if(type.parentId>0) continue
                if(map.has(type.id)){
                    type.children = map.get(type.id)
                }
                data.push({
                    value:type.id,
                    label:type.name,
                    children:type.children
                })
            }

            resolve(data)
        })
    })
}